export default __webpack_public_path__ + "assets/images/3d71e6bc5e9e4821567e27d78bfdf1ec-eco_friendly_packaging.svg";